export default {
  addresses: null,
  _address: null
}
